<template>
    <div class="navigator-metric-cards">
        <div v-for="(card, index) in cards" :key="index" class="navigator-metric-card">
            <div class="navigator-metric-card__label">{{ card.label }}</div>
            <div class="navigator-metric-card__value">
                {{ card.value }}
                <span v-if="card.unit" class="navigator-metric-card__unit">{{ card.unit }}</span>
            </div>
            <div v-if="card.change" class="navigator-metric-card__change"
                :class="changeClass(card)">
                {{ card.change }}
                <span v-if="card.compare_label" class="navigator-metric-card__compare">{{ card.compare_label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavigatorMetricCards',
    props: {
        cards: { type: Array, default: () => [] },
    },
    setup() {
        function changeClass(card) {
            if (card.sentiment === 'positive') return 'navigator-metric-card__change--positive';
            if (card.sentiment === 'negative') return 'navigator-metric-card__change--negative';
            if (card.change && card.change.startsWith('+')) return 'navigator-metric-card__change--positive';
            if (card.change && card.change.startsWith('-')) return 'navigator-metric-card__change--negative';
            return '';
        }
        return { changeClass };
    },
};
</script>

<style scoped>
.navigator-metric-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 12px;
}

.navigator-metric-card {
    background: var(--nav-card-bg, rgba(139, 92, 246, 0.06));
    border: 1px solid var(--nav-card-border, rgba(139, 92, 246, 0.12));
    border-radius: var(--compass-radius-sm, 8px);
    padding: 14px 16px;
    transition: border-color 0.2s;
}

.navigator-metric-card:hover {
    border-color: var(--nav-accent, #8b5cf6);
}

.navigator-metric-card__label {
    font-size: 11px;
    font-weight: 600;
    color: var(--nav-text-muted, #9ca3af);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 6px;
}

.navigator-metric-card__value {
    font-size: 22px;
    font-weight: 700;
    color: var(--nav-text, #f3f4f6);
    font-family: 'JetBrains Mono', monospace;
    line-height: 1.2;
}

.navigator-metric-card__unit {
    font-size: 13px;
    font-weight: 500;
    color: var(--nav-text-muted, #9ca3af);
    margin-left: 2px;
}

.navigator-metric-card__change {
    font-size: 13px;
    font-family: 'JetBrains Mono', monospace;
    margin-top: 6px;
    color: var(--nav-text-secondary, #9ca3af);
}

.navigator-metric-card__change--positive { color: #22c55e; }
.navigator-metric-card__change--negative { color: #ef4444; }

.navigator-metric-card__compare {
    font-family: 'Nunito', sans-serif;
    font-size: 11px;
    color: var(--nav-text-muted, #6b7280);
    margin-left: 4px;
}
</style>
